import {
  Flex,
  Icon,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React, { useState } from 'react';

import { GrFormClose } from 'react-icons/gr';
import BlgButton from '../Button/Button';
import BlgInput from '../Input';
import { useSonarInvite } from '../../api';
import { showNotification } from '../../features/notification';

export interface iModalEpisode {
  isOpen: boolean;
  onClose: () => void;
  selectedPicks: any[];
  episodeId: string;
  resetPickerOptions: () => void;
}

export const BlgModalSonarPlusFinish = ({
  selectedPicks,
  episodeId,
  isOpen,
  onClose,
  resetPickerOptions,
}: iModalEpisode) => {
  const {
    mutateAsync: sendSonarInvite,
    status: sendInviteStatus,
  } = useSonarInvite(episodeId);
  const [groupName, setGroupName] = useState('');
  const onCreateGroup = async () => {
    if (!!selectedPicks.length) {
      try {
        await sendSonarInvite({
          episode_id: episodeId,
          invitee_ids: selectedPicks,
          group_name: groupName,
        });
        showNotification({
          type: 'success',
          title: 'Sonar Sent!',
          message: "Get excited, you're about to be learning together!",
          duration: 3000,
        });
      } catch (e) {
        //
      } finally {
        onClose();
        resetPickerOptions();
        const clearBtn = document.getElementsByClassName(
          'rs-picker-toggle-clean'
        )[0] as HTMLAnchorElement;
        clearBtn?.click();
      }
    }
  };

  console.log(selectedPicks);
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="3xl" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius={18} bg="white" overflow="hidden">
          <ModalHeader
            bg="darkBlue.500"
            p={6}
            display="flex"
            justifyContent="space-between"
            gap={4}
          >
            <Text color="white" fontWeight={700}>
              Finish Sonar Group Setup
            </Text>
            <IconButton
              aria-label="Close"
              icon={<Icon as={GrFormClose} fontSize={24} />}
              colorScheme="whiteAlpha"
              bg="white"
              color="darkBlue.500"
              onClick={onClose}
              borderRadius="full"
              size="sm"
            />
          </ModalHeader>
          <ModalBody p={6}>
            <Flex flexDir="column" w="full" gap={3}>
              <Text color="gray" fontWeight={600}>
                What should we call this group?
              </Text>
              <BlgInput
                placeholder="Learners Pod Period 2"
                shadow="sm"
                onChange={(e) => setGroupName(e.target.value)}
                value={groupName}
              />
              <Flex justifyContent="end" w="full" gap={2}>
                <BlgButton
                  colorScheme="newGreen"
                  shadow="md"
                  isDisabled={!selectedPicks.length || !groupName.length}
                  isLoading={sendInviteStatus === 'loading'}
                  onClick={() => onCreateGroup()}
                >
                  Create Group
                </BlgButton>
                <BlgButton colorScheme="red" shadow="md" onClick={onClose}>
                  Cancel
                </BlgButton>
              </Flex>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
